/**
 * Persists clients list UI prefs per tenant (Opções quick action).
 */
export const CLIENTS_LAST_OPTIONS_ACTION_BY_TENANT_KEY =
  "adatis.clients.lastOptionsActionByTenant";

export type ClientsOptionsActionPreference = "import" | "merge" | "guide";

const CLIENTS_OPTIONS_ACTIONS: ClientsOptionsActionPreference[] = [
  "import",
  "merge",
  "guide",
];

type StringByTenantMap = Record<string, string>;

const readMap = (key: string): StringByTenantMap => {
  if (typeof window === "undefined") {
    return {};
  }

  try {
    const raw = localStorage.getItem(key);

    if (!raw) {
      return {};
    }

    const parsed = JSON.parse(raw) as unknown;

    if (!parsed || typeof parsed !== "object" || Array.isArray(parsed)) {
      return {};
    }

    return parsed as StringByTenantMap;
  } catch {
    return {};
  }
};

const writeMap = (key: string, map: StringByTenantMap): void => {
  if (typeof window === "undefined") {
    return;
  }

  try {
    localStorage.setItem(key, JSON.stringify(map));
  } catch {
    // ignore quota / private mode
  }
};

export const getClientsLastOptionsActionForTenant = (
  tenantId: number | null | undefined
): ClientsOptionsActionPreference | null => {
  if (tenantId == null || !Number.isFinite(tenantId)) {
    return null;
  }

  const value = readMap(CLIENTS_LAST_OPTIONS_ACTION_BY_TENANT_KEY)[String(tenantId)];

  return CLIENTS_OPTIONS_ACTIONS.includes(value as ClientsOptionsActionPreference)
    ? (value as ClientsOptionsActionPreference)
    : null;
};

export const setClientsLastOptionsActionForTenant = (
  tenantId: number | null | undefined,
  action: ClientsOptionsActionPreference
): void => {
  if (tenantId == null || !Number.isFinite(tenantId)) {
    return;
  }

  const map = readMap(CLIENTS_LAST_OPTIONS_ACTION_BY_TENANT_KEY);
  map[String(tenantId)] = action;
  writeMap(CLIENTS_LAST_OPTIONS_ACTION_BY_TENANT_KEY, map);
};
